


import React from "react";
import styled from "styled-components";
import { BrandLogo } from "../../components/brandLogo";
import { Button } from "../../components/button";

import FarmingImg from "../../images/cancelamento.png";
import { Marginer } from "../../components/marginer";
import { deviceSize } from "../../components/responsive";
import { useMediaQuery } from "react-responsive";

const SpecialistAdContainer = styled.div`
  width: 100%;
  height: 660px;
  display: flex;
  background: rgb(7,51,215);
background: linear-gradient(90deg, rgba(7,51,215,1) 7%, rgba(92,47,213,1) 83%);
  align-items: center;
  justify-content: center;
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    flex-direction: column-reverse;
  }
`;

const SloganContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-right: 5em;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    align-items: center;
    margin: 0;
  }
`;

const Slogan = styled.h2`
  margin: 0;
  font-size: 24px;
  color: #fff;
  font-weight: 700;
  line-height: 1.3;
  text-align: start;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 20px;
  }
`;

const StandoutImage = styled.div`
  width: 35em;
  height: 29em;

  img {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 18em;
    height: 14em;
  }
`;

const SloganS = styled.div`

padding:17px;
font-size:44px;
color:#ffffff;
`

const SloganM = styled.div`

padding:17px;
font-size:24px;
color:#ffffff;
`


const SloganN = styled.div`
padding:17px;
font-size:22px;
color:#ffffff;
margin-bottom:-14px;



`


const SloganV = styled.div`
padding:17px;
font-size:22px;
color:#ffffff;
margin-top:-15px;



`

const ButtonNice= styled.div`
background-color:#ffffff;
padding:13px;
margin-left:17px;
width:350px;
border-radius:36px;
color:#1f1f7a;
font-weight:bold;



`

export function Services(props) {
  const isMobile = useMediaQuery({ maxWidth: deviceSize.mobile });

  return (
    <SpecialistAdContainer>
      <ContentContainer>
        <SloganContainer>
         
          <Marginer direction="vertical" margin="1em" />
          <SloganContainer>
            <SloganS>Você esta na Área de Cancelamento  </SloganS>
            <SloganN>Em caso de inadimplência por boletos em aberto no sistema, </SloganN>
            <SloganV>a Somatto reserva-se no direito de negativação do associado.</SloganV>
            
          </SloganContainer>
          <Marginer direction="vertical" margin="0.8em" />
         
        </SloganContainer>
        <StandoutImage>
          <img src={FarmingImg} alt="join-as-specialist" />
        </StandoutImage>
      </ContentContainer>
    </SpecialistAdContainer>
  );
}
